export default {
    getCompletionTable: (state) => state.completionTable,
  }